import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import imgCodeTypes from 'assets/images/promo_codes/code_types.png'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('promo_codes.overview.code_types')

const CodeTypes = () => {
  const [css] = useStyletron()

  return (
    <section
      data-testid="promo-codes-code-types"
      className={css({
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
        gap: '32px',
        alignItems: 'start',
      })}
    >
      <div>
        <Text.Header3 tag="h2" color="grey90" className="mt-0 mb-s">
          {t('title')}
        </Text.Header3>
        <Text.BodyText3 color="grey70" tag="p" className="mb-0">
          {t('body')}
        </Text.BodyText3>
      </div>
      <img
        data-testid="promo-codes-code-types-visual"
        src={imgCodeTypes}
        alt={t('image_alt')}
        className={css({ width: '100%', height: 'auto' })}
      />
    </section>
  )
}

export default CodeTypes
